import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

export const rowStyles = makeStyles((theme: Theme) =>
    createStyles({
        expandButton: {
            fill: theme.colors.neutrals.neutral500,
            padding: "20px 12px",
            width: "100%",
            height: "100%",
        },

        cell: {
            padding: "12px",
            borderBottomColor: theme.colors.neutrals.neutral200,
        },

        expandCell: {
            padding: 0,

            "& svg": {
                width: 12,
            },
        },
    })
);
